//==
export var ActiveListingsStatus;
(function (ActiveListingsStatus) {
    ActiveListingsStatus[ActiveListingsStatus["ForSale"] = 0] = "ForSale";
    ActiveListingsStatus[ActiveListingsStatus["ForSaleDesc"] = "For Sale"] = "ForSaleDesc";
    ActiveListingsStatus[ActiveListingsStatus["New"] = 1] = "New";
    ActiveListingsStatus[ActiveListingsStatus["NewDesc"] = "New"] = "NewDesc";
    ActiveListingsStatus[ActiveListingsStatus["OnShow"] = 2] = "OnShow";
    ActiveListingsStatus[ActiveListingsStatus["OnShowDesc"] = "On Show"] = "OnShowDesc";
    ActiveListingsStatus[ActiveListingsStatus["PriceReduced"] = 3] = "PriceReduced";
    ActiveListingsStatus[ActiveListingsStatus["PriceReducedDesc"] = "Price Reduced"] = "PriceReducedDesc";
    ActiveListingsStatus[ActiveListingsStatus["BackOnMarket"] = 4] = "BackOnMarket";
    ActiveListingsStatus[ActiveListingsStatus["BackOnMarketDesc"] = "Back On Market"] = "BackOnMarketDesc";
    ActiveListingsStatus[ActiveListingsStatus["Sold"] = 5] = "Sold";
    ActiveListingsStatus[ActiveListingsStatus["SoldDesc"] = "Sold"] = "SoldDesc";
    ActiveListingsStatus[ActiveListingsStatus["Negotiable"] = 6] = "Negotiable";
    ActiveListingsStatus[ActiveListingsStatus["NegotiableDesc"] = "Negotiable"] = "NegotiableDesc";
    ActiveListingsStatus[ActiveListingsStatus["OfferPending"] = 7] = "OfferPending";
    ActiveListingsStatus[ActiveListingsStatus["OfferPendingDesc"] = "Offer Pending"] = "OfferPendingDesc";
})(ActiveListingsStatus || (ActiveListingsStatus = {}));
